/**
 * @flow
 * @relayHash a6ec9eefa3264f86f50b7c53ce76a148
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type GlobalSearchFrags_root$ref = any;
export type GlobalSearchQueryVariables = {|
  limit?: ?number,
  search?: ?string,
|};
export type GlobalSearchQueryResponse = {|
  +$fragmentRefs: GlobalSearchFrags_root$ref
|};
export type GlobalSearchQuery = {|
  variables: GlobalSearchQueryVariables,
  response: GlobalSearchQueryResponse,
|};
*/


/*
query GlobalSearchQuery(
  $limit: Int
  $search: String
) {
  ...GlobalSearchFrags_root
}

fragment GlobalSearchFrags_root on Query {
  globalSearch(search: $search, limit: $limit) {
    users {
      totalCount
      results {
        id
        email
        firstName
        lastName
        primaryImage {
          url
          id
        }
        ...UserAvatar_user
      }
    }
    organisations {
      totalCount
      results {
        id
        name
        street
        city
        primaryImage {
          url
          id
        }
        ...UserAvatar_organisation
      }
    }
    activities {
      totalCount
      results {
        id
        note
        subject
        parent {
          __typename
          id
          ... on Lead {
            deal {
              id
              name
            }
            organisation {
              id
              name
              ...UserAvatar_organisation
            }
          }
          ... on Deal {
            name
            image {
              url
              id
            }
          }
          ... on User {
            fullName
            ...UserAvatar_user
          }
          ... on Organisation {
            name
            ...UserAvatar_organisation
          }
        }
        user {
          firstName
          lastName
          id
        }
        creator {
          firstName
          lastName
          id
        }
        deal {
          id
          name
          title
          titleEn: title(lang: "en")
          titleDe: title(lang: "de")
          titleFr: title(lang: "fr")
        }
        organisation {
          name
          id
        }
      }
    }
    deals {
      totalCount
      results {
        id
        name
        titleEn: title(lang: "en")
        titleDe: title(lang: "de")
        titleFr: title(lang: "fr")
        image {
          url
          id
        }
      }
    }
  }
}

fragment UserAvatar_user on User {
  id
  firstName
  lastName
  fullName
  primaryImage {
    url
    id
  }
}

fragment UserAvatar_organisation on Organisation {
  id
  name
  primaryImage {
    url
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
  (v2/*: any*/)
],
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "primaryImage",
  "storageKey": null,
  "args": null,
  "concreteType": "Image",
  "plural": false,
  "selections": (v5/*: any*/)
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "image",
  "storageKey": null,
  "args": null,
  "concreteType": "Image",
  "plural": false,
  "selections": (v5/*: any*/)
},
v10 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v2/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "alias": "titleEn",
  "name": "title",
  "args": [
    {
      "kind": "Literal",
      "name": "lang",
      "value": "en"
    }
  ],
  "storageKey": "title(lang:\"en\")"
},
v12 = {
  "kind": "ScalarField",
  "alias": "titleDe",
  "name": "title",
  "args": [
    {
      "kind": "Literal",
      "name": "lang",
      "value": "de"
    }
  ],
  "storageKey": "title(lang:\"de\")"
},
v13 = {
  "kind": "ScalarField",
  "alias": "titleFr",
  "name": "title",
  "args": [
    {
      "kind": "Literal",
      "name": "lang",
      "value": "fr"
    }
  ],
  "storageKey": "title(lang:\"fr\")"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GlobalSearchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "GlobalSearchFrags_root",
        "args": null
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "GlobalSearchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "globalSearch",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
          },
          {
            "kind": "Variable",
            "name": "search",
            "variableName": "search"
          }
        ],
        "concreteType": "GlobalSearch",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "users",
            "storageKey": null,
            "args": null,
            "concreteType": "GlobalSearchUser",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "results",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "organisations",
            "storageKey": null,
            "args": null,
            "concreteType": "GlobalSearchOrganisation",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "results",
                "storageKey": null,
                "args": null,
                "concreteType": "Organisation",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "street",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "city",
                    "args": null,
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "activities",
            "storageKey": null,
            "args": null,
            "concreteType": "GlobalSearchActivity",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "results",
                "storageKey": null,
                "args": null,
                "concreteType": "Activity",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "note",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "subject",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "parent",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "Lead",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "deal",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Deal",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "organisation",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Organisation",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "Deal",
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "User",
                        "selections": [
                          (v7/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "Organisation",
                        "selections": [
                          (v8/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": (v10/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": (v10/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "deal",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Deal",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "organisation",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "deals",
            "storageKey": null,
            "args": null,
            "concreteType": "GlobalSearchDeal",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "results",
                "storageKey": null,
                "args": null,
                "concreteType": "Deal",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "GlobalSearchQuery",
    "id": null,
    "text": "query GlobalSearchQuery(\n  $limit: Int\n  $search: String\n) {\n  ...GlobalSearchFrags_root\n}\n\nfragment GlobalSearchFrags_root on Query {\n  globalSearch(search: $search, limit: $limit) {\n    users {\n      totalCount\n      results {\n        id\n        email\n        firstName\n        lastName\n        primaryImage {\n          url\n          id\n        }\n        ...UserAvatar_user\n      }\n    }\n    organisations {\n      totalCount\n      results {\n        id\n        name\n        street\n        city\n        primaryImage {\n          url\n          id\n        }\n        ...UserAvatar_organisation\n      }\n    }\n    activities {\n      totalCount\n      results {\n        id\n        note\n        subject\n        parent {\n          __typename\n          id\n          ... on Lead {\n            deal {\n              id\n              name\n            }\n            organisation {\n              id\n              name\n              ...UserAvatar_organisation\n            }\n          }\n          ... on Deal {\n            name\n            image {\n              url\n              id\n            }\n          }\n          ... on User {\n            fullName\n            ...UserAvatar_user\n          }\n          ... on Organisation {\n            name\n            ...UserAvatar_organisation\n          }\n        }\n        user {\n          firstName\n          lastName\n          id\n        }\n        creator {\n          firstName\n          lastName\n          id\n        }\n        deal {\n          id\n          name\n          title\n          titleEn: title(lang: \"en\")\n          titleDe: title(lang: \"de\")\n          titleFr: title(lang: \"fr\")\n        }\n        organisation {\n          name\n          id\n        }\n      }\n    }\n    deals {\n      totalCount\n      results {\n        id\n        name\n        titleEn: title(lang: \"en\")\n        titleDe: title(lang: \"de\")\n        titleFr: title(lang: \"fr\")\n        image {\n          url\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment UserAvatar_user on User {\n  id\n  firstName\n  lastName\n  fullName\n  primaryImage {\n    url\n    id\n  }\n}\n\nfragment UserAvatar_organisation on Organisation {\n  id\n  name\n  primaryImage {\n    url\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '79789863aa3002ef51caed6eba507593';
module.exports = node;
